import { useMemo } from 'react';
import { ChartDataPoint, ChartSeries } from '../types';

export function useSeriesChartEvents(
  series: ChartSeries[],
  onDataPointClick?: (dataPoint: ChartDataPoint, series: ChartSeries) => void,
  onSeriesClick?: (series: ChartSeries) => void
): Record<string, (params: unknown) => void> | undefined {
  return useMemo(() => {
    const events: Record<string, (params: unknown) => void> = {};

    const getClickParams = (params: unknown) => params as { name?: string; seriesName?: string };

    if (onDataPointClick) {
      events.click = (params: unknown) => {
        const p = getClickParams(params);
        const clickedSeries = series.find(s => s.label === p.seriesName);
        if (clickedSeries) {
          const dataPoint = clickedSeries.data.find(pt => String(pt.x) === p.name);
          if (dataPoint) {
            onDataPointClick(dataPoint, clickedSeries);
          }
        }
      };
    }

    if (onSeriesClick) {
      events.legendselectchanged = (params: unknown) => {
        const p = getClickParams(params);
        const clickedSeries = series.find(s => s.label === p.name);
        if (clickedSeries) {
          onSeriesClick(clickedSeries);
        }
      };
    }

    return Object.keys(events).length > 0 ? events : undefined;
  }, [series, onDataPointClick, onSeriesClick]);
}
